// test1058
(1058 && 0);
